// extracted by mini-css-extract-plugin
export default {"content":"Profile_content__jXSw9","contact":"Profile_contact__lJ6gu","button":"Profile_button__gHp6Z"};